import React from 'react';
import FormView from '../../../components/common/Forms/FormView';

/**
 * AdmFormView - Page wrapper for viewing filled Admin forms
 * Used for navigation in routes.
 */
const DccFormView: React.FC = () => {
  return <FormView />;
};

export default DccFormView;
